import module from 'kendu/legacy/module'

module.directive('development', ($window) => ({
  restrict: 'A',
  transclude: 'element',
  priority: 600,
  terminal: true,
  $$tlb: true,
  link ($scope, $element, $attr, ctrl, $transclude) {
    if ($window.location.hostname === 'localhost') {
      $transclude((clone) => {
        $element.replaceWith(clone)
      })
    }
  },
}))



// WEBPACK FOOTER //
// ./src/deprecated/directive/development/component.js